// 电影演示数据（虚构内容，仅用于演示）
export const movieItems = [
  {
    id: "star-edge",
    title: "星尘边缘",
    type: "movie",
    year: 2026,
    region: "中国大陆",
    director: "顾南舟",
    cast: ["林亦扬", "苏挽", "周砚"],
    genres: ["科幻", "冒险"],
    updatedAt: "2026-10-12",
    views: 182000,
    rating: 8.7,
    poster: "https://readdy.ai/api/search-image?query=A%20lone%20astronaut%20gazing%20at%20a%20glowing%20planet%20edge%20in%20deep%20space%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=A%20vast%20starfield%20with%20a%20luminous%20planet%20horizon%20and%20a%20tiny%20spacecraft%20silhouette%2C%20cinematic%20wide%20banner%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=zc-b01&orientation=landscape",
    summary: "一名深空勘探员在废弃空间站里发现了改写人类命运的信标。",
    synopsis: "深空勘探员里程在一次例行巡航中接收到一段来历不明的信号，信号源头是一座早已被废弃的轨道空间站。随着他一步步深入站内，尘封的实验记录与失踪者名单逐渐浮出水面，一个关于人类起源的秘密也随之逼近真相。影片以冷峻的太空场景与克制的情绪描写，讲述孤独、记忆与选择的故事。",
    subtitleNote: "已上线 简体中文 / 繁体中文 双语字幕，含台词双语对照与时间轴校准版本，支持自由切换。",
    featured: true,
  },
  {
    id: "rising-city",
    title: "暗涌之城",
    type: "movie",
    year: 2025,
    region: "中国香港",
    director: "麦子谦",
    cast: ["高维", "梁浠", "何兆铭"],
    genres: ["犯罪", "悬疑"],
    updatedAt: "2026-10-10",
    views: 154000,
    rating: 8.4,
    poster: "https://readdy.ai/api/search-image?query=Rainy%20neon%20city%20street%20at%20night%20with%20a%20silhouetted%20detective%20holding%20an%20umbrella%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=A%20rain%20slicked%20downtown%20skyline%20at%20night%20with%20glowing%20signage%20and%20long%20reflections%2C%20cinematic%20wide%20banner%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=zc-b02&orientation=landscape",
    summary: "一桩旧案将退休警探重新拉回雨夜迷城，真相远比罪案更冷。",
    synopsis: "退休警探陈九言本已淡出江湖，却在整理旧物时发现一份被刻意抹去的卷宗。为了查明故人之死的真相，他重新踏入这座永远在下雨的城市，游走于线人、旧友与幕后势力之间。当所有线索汇聚，他发现真正的暗涌并不在街头，而藏在每一个微笑背后。",
    subtitleNote: "已上线 简体中文 字幕，粤语原声保留，附带注释字幕版本解释方言与俚语。",
    featured: true,
  },
  {
    id: "spring-alert",
    title: "春日告急",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    director: "沈温",
    cast: ["许清和", "罗蔓"],
    genres: ["爱情", "剧情"],
    updatedAt: "2026-09-30",
    views: 98000,
    rating: 7.9,
    poster: "https://readdy.ai/api/search-image?query=Two%20figures%20standing%20under%20spring%20blossoms%20in%20soft%20sunlight%20with%20petals%20falling%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m03&orientation=portrait",
    summary: "两个在春天错过的人，用一整个四季重新找回彼此。",
    synopsis: "插画师祝晴在一次春日市集上偶遇即将出国深造的老同学陆行舟，两人因一场误会闹得不欢而散。此后一年，他们在不同的城市、不同的季节里反复靠近又分开，直到春天再次来临。影片用温柔克制的镜头语言，讲述一段关于错过与重逢的都市爱情。",
    subtitleNote: "已上线 简体中文 / 繁体中文 字幕，含歌词字幕与配乐注释。",
  },
  {
    id: "iron-city",
    title: "铁血孤城",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    director: "贺东风",
    cast: ["郑铁山", "白露", "田川"],
    genres: ["战争", "历史"],
    updatedAt: "2026-09-22",
    views: 87000,
    rating: 8.1,
    poster: "https://readdy.ai/api/search-image?query=A%20weathered%20soldier%20standing%20before%20an%20ancient%20stone%20fortress%20at%20dusk%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m04&orientation=portrait",
    summary: "一座孤城，一支残兵，一场注定被历史遗忘的坚守。",
    synopsis: "战火燃至边陲小城，守将郑铁山奉命率三百残兵坚守七日，等待几乎不会到来的援军。粮草将尽、城墙将破，他必须在忠义与生死之间做出抉择。影片以写实的战场质感与克制的人物刻画，再现一段被尘封的守城往事。",
    subtitleNote: "已上线 简体中文 字幕，配备历史背景注释字幕与人物关系说明。",
  },
  {
    id: "fog-echo",
    title: "迷雾回声",
    type: "movie",
    year: 2026,
    region: "中国大陆",
    director: "骆宁",
    cast: ["邱远", "叶紫"],
    genres: ["悬疑", "惊悚"],
    updatedAt: "2026-10-08",
    views: 121000,
    rating: 8.2,
    poster: "https://readdy.ai/api/search-image?query=A%20foggy%20forest%20path%20with%20a%20distant%20lone%20figure%20and%20a%20faint%20glow%20between%20the%20trees%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m05&orientation=portrait",
    summary: "七年前的山中失踪案，随着一场大雾再次回到人们视野。",
    synopsis: "记者叶紫为调查一桩沉寂七年的山林失踪案回到故乡，浓雾封山的第一个夜晚，她听见了不该出现的声音。随着调查深入，小镇上每个人似乎都藏着一段不愿提起的往事。当迷雾散去，回声却指向了一个更令人不安的答案。",
    subtitleNote: "已上线 简体中文 字幕，含环境音提示字幕（适合听障观众）。",
  },
  {
    id: "smile-trainee",
    title: "微笑练习生",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    director: "蔡悦",
    cast: ["丁小满", "周吉", "安琪"],
    genres: ["喜剧", "剧情"],
    updatedAt: "2026-09-15",
    views: 64000,
    rating: 7.3,
    poster: "https://readdy.ai/api/search-image?query=A%20cheerful%20young%20performer%20mid%20dance%20on%20a%20bright%20studio%20stage%20with%20spotlights%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m06&orientation=portrait",
    summary: "五个被淘汰的练习生组队逆袭，笑料与热泪齐飞。",
    synopsis: "在接连被经纪公司淘汰后，五个性格迥异的练习生阴差阳错地组成了一支临时组合。他们一边打工一边排练，用最笨拙的方式追逐舞台上的一束光。影片以轻松幽默的节奏，讲述一群普通人关于热爱与坚持的故事。",
    subtitleNote: "已上线 简体中文 字幕，含歌舞片段歌词字幕。",
  },
  {
    id: "deep-beacon",
    title: "深海信标",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    director: "顾南舟",
    cast: ["苏挽", "方骁"],
    genres: ["科幻", "剧情"],
    updatedAt: "2026-10-05",
    views: 133000,
    rating: 8.5,
    poster: "https://readdy.ai/api/search-image?query=An%20underwater%20beacon%20glowing%20in%20deep%20ocean%20darkness%20surrounded%20by%20marine%20snow%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m07&orientation=portrait",
    summary: "万米海沟之下，一段沉寂三十年的信号重新亮起。",
    synopsis: "海洋工程师苏挽受邀参与一次深海探测任务，目标是打捞一座失联三十年的水下信标。当潜航器抵达海沟底部，她发现信标记录的不只是数据，还有上一代勘探者留下的最后留言。影片融合科幻设定与亲情线索，在幽暗海底讲述一段关于传承的旅程。",
    subtitleNote: "已上线 简体中文 / 繁体中文 字幕，含专业术语注释。",
  },
  {
    id: "wind-chasers",
    title: "追风少年团",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    director: "蔡悦",
    cast: ["丁小满", "林一诺"],
    genres: ["剧情", "运动"],
    updatedAt: "2026-09-08",
    views: 45000,
    rating: 7.1,
    poster: "https://readdy.ai/api/search-image?query=Teenagers%20cycling%20along%20a%20coastal%20road%20at%20golden%20hour%20with%20lens%20flare%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m08&orientation=portrait",
    summary: "一支乡下自行车队，骑向全国少年锦标赛的夏天。",
    synopsis: "小镇少年阿满最大的愿望，是带着一群伙伴骑出家乡。他们在废弃公路上练习，凑钱买零件，用最简陋装备挑战专业队伍。一个充满汗水与欢笑的夏天过后，他们终于站在了全国少年锦标赛的起跑线上。",
    subtitleNote: "已上线 简体中文 字幕，含方言对白注释。",
  },
  {
    id: "north-30",
    title: "北纬三十度",
    type: "movie",
    year: 2020,
    region: "中国大陆",
    director: "骆宁",
    cast: ["贺川", "白露"],
    genres: ["冒险", "剧情"],
    updatedAt: "2026-08-28",
    views: 39000,
    rating: 7.6,
    poster: "https://readdy.ai/api/search-image?query=A%20lone%20hiker%20on%20a%20mountain%20ridge%20above%20a%20sea%20of%20clouds%20at%20dawn%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m09&orientation=portrait",
    summary: "一条穿越神秘纬度的徒步路线，一场与自己的较量。",
    synopsis: "地质学家贺川为完成亡兄未竟的勘测计划，独自踏上北纬三十度沿线的徒步路线。从雪线到峡谷，他在极端环境中一次次逼近极限，也一次次与过往的自己和解。影片用壮阔的自然景观，讲述一段关于勇气与告别的故事。",
    subtitleNote: "已上线 简体中文 字幕，含地理知识注释字幕。",
  },
  {
    id: "tender-night",
    title: "夜色温柔",
    type: "movie",
    year: 2019,
    region: "中国台湾",
    director: "沈温",
    cast: ["纪然", "温若"],
    genres: ["爱情", "剧情"],
    updatedAt: "2026-08-20",
    views: 33000,
    rating: 7.4,
    poster: "https://readdy.ai/api/search-image?query=Warm%20evening%20city%20lights%20reflected%20on%20a%20quiet%20river%20with%20a%20couple%20walking%20hand%20in%20hand%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-m10&orientation=portrait",
    summary: "两个失眠的人，在城市的夜里慢慢靠近。",
    synopsis: "失眠的电台主播与夜班便利店店员在一座城市里反复相遇，从一句问候到彼此习惯对方的出现。他们没有轰轰烈烈的告白，只有无数个安静的夜晚。影片以细腻的日常描写，讲述一段发生在夜色里的温柔爱情。",
    subtitleNote: "已上线 简体中文 / 繁体中文 字幕，含台语对白注释。",
  },
];